import { DOMINANT_BASELINE_MIDDLE, TEXT_ANCHOR_MIDDLE } from '%paysera_seat_selection/js/seatSelection/config/constants';

function calculateCircleSeatLabel(
    seat,
    seatConfig,
    fontConfig,
    text,
) {
    const compiled = {
        ...seat.label.compiled,
        size: fontConfig.size.seat,
        family: fontConfig.family,
        color: seat.enabled ? fontConfig.color : seatConfig.disabled.textColor,
        x: -seatConfig.size / 2,
    };

    compiled.text = { ...compiled.text, x: compiled.x, y: compiled.y };

    return {
        ...seat.label,
        textAnchor: TEXT_ANCHOR_MIDDLE,
        dominantBaseline: DOMINANT_BASELINE_MIDDLE,
        compiled,
        text,
    };
}

export default calculateCircleSeatLabel;
